import React from 'react'
import PropTypes from 'prop-types'
import i18n from '../../../simple-react-i18n'
import ExportFileModal from '../../../components/modal/ExportFileModal'
import ExportAction from '../../../export/actions/ExportAction'
import { useDispatch } from 'react-redux'
import { formatData } from '../../../utils/ExportDataUtil'
import {getFullDate} from "../../../utils/DateUtil";
import moment from "moment/moment";

const LogCmsExport = ({
    isOpen,
    setIsOpen,
    cms,
    headers,
}) => {
    const dispatch = useDispatch()

    const formatCMS = exportFormat => {
        const format = cms.map(c => ({ ...c, status: c.valueStatus }))
        const dataWithHeaders = format.length ? [
            { ...format[0], headers },
            ...format.slice(1),
        ] : []
        dispatch(ExportAction.export(formatData(dataWithHeaders), exportFormat, `summary_CMS_${getFullDate(moment().valueOf())}`))
    }

    return (
        <ExportFileModal
            open={isOpen}
            onClose={() => setIsOpen(false)}
            data={[{
                name: i18n.export,
                formats: [{
                    type: i18n.excelFile,
                    callback: () => formatCMS('xlsx'),
                }, {
                    type: i18n.csvFile,
                    callback: () => formatCMS('csv'),
                }],
            }]}
        />
    )
}

LogCmsExport.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    cms: PropTypes.shape({
        contactCode: PropTypes.number,
        date: PropTypes.number,
        dateSend: PropTypes.string,
        idCms: PropTypes.number,
        recipient: PropTypes.string,
        sortValue: PropTypes.string,
        status: PropTypes.string,
        value: PropTypes.element,
        updateDate: PropTypes.string,
        valueStatus: PropTypes.string,
    }),
    headers: PropTypes.arrayOf(PropTypes.string),
}

export default LogCmsExport